import { ChangeEvent, FC, useCallback } from 'react';
import useUserSettings from '@/hooks/use-user-settings.hook';
import PreferenceControl from './preference-control';

interface Props {
  inline?: boolean;
}

const ThemeModeControl: FC<Props> = ({ inline }) => {
  const {
    preferences: { colorMode },
    patchPreferences,
  } = useUserSettings();

  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      patchPreferences({ colorMode: event.target.checked ? 'dark' : 'light' });
    },
    [patchPreferences]
  );

  return (
    <PreferenceControl
      label="Dark mode"
      checked={colorMode === 'dark'}
      onChange={handleChange}
      tooltip="When enabled, a dark theme will be used for the entire page"
      inline={inline}
    />
  );
};

export default ThemeModeControl;
